import { useLocation } from 'react-router';
import { Navigate } from '@flame-frontend-utils/commons-router6';
import { LoadingPage } from '../LoadingPage';
import { useFilterByTag } from './hooks';
import { LoadableMasonry } from '../../components/FilterView';
import { ROUTES } from '../../lib/ROUTES';
import { TagDetailPage } from './TagDetailPage';

const TagPage = () => {
  const location = useLocation();

  return <TagPageContent key={location.pathname} pathname={location.pathname} />;
};

interface TagPageContentProps {
  pathname: string;
}

const TagPageContent = ({ pathname }: TagPageContentProps) => {
  const { data, onFetchMore } = useFilterByTag();

  if (data?.tag) {
    const canonicalPathname = ROUTES.TAG_FILTER.$buildPath({ params: { id: data.tag.alias } });

    if (pathname !== canonicalPathname) {
      return <Navigate to={canonicalPathname} replace statusCode={301} />;
    }
    return (
      <TagDetailPage tag={data.tag}>
        <LoadableMasonry
          posts={data.mediaPosts.items}
          hasNextPage={data.mediaPosts.pageInfo.hasNextPage}
          onFetchMore={onFetchMore}
          maxColumns={4}
        />
      </TagDetailPage>
    );
  }

  if (data) {
    return <Navigate to={ROUTES.ROOT.$buildPath({})} replace statusCode={301} />;
  }

  return <LoadingPage />;
};

export default TagPage;
export { TagPage };
